var map = {
	"./Favicon.png": 435,
	"./Favicon2.png": 961,
	"./Favicon3.png": 344,
	"./Favicon4.png": 863,
	"./GoBang.gif": 460,
	"./PulsePursuit.GIF": 808,
	"./Sidebar1.jpg": 922,
	"./Splash1.jpg": 213,
	"./Splash2.jpg": 722,
	"./Spread.jpg": 458,
	"./TapeDeck.GIF": 80
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 187;